import React, { useState } from "react";
import { Tab } from "semantic-ui-react";
import { ListFrequencies } from "../../../components/Admin/Frequencies";
import { useLanguage } from "../../../contexts";
import "./Frequencies.scss";

export function Frequencies() {
  const { translations } = useLanguage();
  const t = (key) => translations[key] || key;
  const [reload, setReload] = useState(false);
  const onReload = () => setReload((prev) => !prev);

  const panes = [
    {
      menuItem: t("active_frequencies"),
      render: () => (
        <Tab.Pane attached={false}>
          <ListFrequencies frequenciesActive={true} reload={reload} onReload={onReload} />
        </Tab.Pane>
      ),
    },
    {
      menuItem: t("inactive_frequencies"),
      render: () => (
        <Tab.Pane attached={false}>
          <ListFrequencies frequenciesActive={false} reload={reload} onReload={onReload} />
        </Tab.Pane>
      ),
    },
  ];

  return (
    <div className="frequencies-page" style={{ padding: "0 0 1.5rem" }}>
      <div className="frequencies-page-header-wrapper">
        <div className="frequencies-page-header">
          <span className="frequencies-page-title">{translations.frequencies}</span>
        </div>
      </div>
      <Tab menu={{ secondary: true, pointing: true }} panes={panes} />
    </div>
  );
}
